<template>
    <div class="min-h-screen w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="container mx-auto my-4 sm:my-16 px-4 sm:px-8">
            <coming-soon :title="campusName" :show-button="true" button-text="Coming Soon" button-icon="clock" />
        </div>
    </div>
</template>
<script>
export default {
    name: "adpoly-campus",
    props: ["campus"],
    created() {
        this.isValidCampus();
    },
    computed: {
        campusName() {
            const campusMap = {
                'al-mafraq': 'Al Mafraq Campus',
                'ajman': 'Ajman Campus',
                'al-dhafra': 'Al Dhafra Campus',
            };

            const campus = this.campus ? this.campus.toLowerCase() : '';
            return campusMap[campus] || '';
        },
    },
    methods: {
        isValidCampus() {
            const validCampuses = ['al-mafraq', 'ajman', 'al-dhafra'];
            if (!this.campus || !validCampuses.includes(this.campus.toLowerCase())) {
                this.$router.push({ path: '/notFound' });
            }
        },
    },
}
</script>